import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import WizardInput from 'components/wizard/WizardInput';
import { Col, Row } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

const Tva = ['19', '13', '7', '0'];

const InfosProduit = ({ register, errors, watch, setValue }) => {
  const [prix, setPrix] = useState({ prixHT: 0, prixTTC: 0 });
  const [tva, setTva] = useState(watch('tva') || Tva[0]);
  const [typeTva, setTypeTva] = useState(watch('typeTva') || 'TTC');
  const prixUnitaire = watch('prix');
  // Calculate prixHT and prixTTC whenever the watched values change
  useEffect(() => {
    if (prixUnitaire && tva && typeTva) {
      const tvaRate = parseFloat(tva) / 100;
      const prixUnitaireValue = parseFloat(prixUnitaire);

      if (typeTva === 'HT') {
        setPrix({
          prixHT: prixUnitaireValue,
          prixTTC: prixUnitaireValue + prixUnitaireValue * tvaRate
        });
      } else if (typeTva === 'TTC') {
        setPrix({
          prixHT: prixUnitaireValue / (1 + tvaRate),
          prixTTC: prixUnitaireValue
        });
      }
    } else {
      setPrix({ prixHT: 0, prixTTC: 0 });
    }
  }, [prixUnitaire, tva, typeTva]);

  return (
    <>
      <WizardInput
        label="Nom du produit*"
        name="produit"
        errors={errors}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('produit', {
            required: 'Nom du produit est obligatoire',
            minLength: {
              value: 1,
              message: 'Nom du produit est obligatoire'
            }
          })
        }}
      />
      <Row className="g-2 mb-3">
        {Tva.map((tvaValue, index) => (
          <Col key={index}>
            <>
              <Form.Check
                inline
                type="radio"
                id="item1Radio"
                label={`${tvaValue}%`}
                name={`item1Radio`}
                onClick={() => {
                  setTva(Tva[index]);
                  setValue('tva', Tva[index]);
                }}
                defaultChecked={tva === Tva[index]}
              />
            </>
          </Col>
        ))}
      </Row>
      <Row className="g-2 mb-1">
        <WizardInput
          type="number"
          errors={errors}
          label="Prix unitaire*"
          name="prix"
          formGroupProps={{ className: 'mb-3' }}
          formControlProps={{
            ...register('prix', {
              required: 'Champ Prix obligatoire',
              pattern: {
                value: /^\d+(\.\d+)?$/, // Matches integers or decimals
                message: 'Please enter a valid decimal value'
              },

              minLength: {
                value: 1,
                message: 'Vous devrez spécifier le prix unitaire'
              }
            })
          }}
        />
      </Row>
      <Row className="g-2 mb-0 d-flex align-items-center justify-content-start">
        <Col sm="auto">
          <Form.Check
            inline
            type="radio"
            id="item2Radio"
            label={`TTC`}
            name={`item2Radio`}
            onClick={() => {
              setTypeTva('TTC');
              setValue('typeTva', typeTva);
            }}
            defaultChecked={typeTva === 'TTC'}
          />
          <p style={{ marginLeft: '5px' }}>
            Prix HT: {prix.prixTTC.toFixed(3)}
          </p>
        </Col>
        <Col sm="auto" className="ms-3">
          <Form.Check
            inline
            type="radio"
            id="item2Radio"
            label={`HT`}
            name={`item2Radio`}
            onClick={() => {
              setTypeTva('HT');
              setValue('typeTva', typeTva);
            }}
            defaultChecked={typeTva === 'HT'}
          />
          <p style={{ marginLeft: '5px' }}>
            Prix TTC: {prix.prixHT.toFixed(3)}
          </p>
        </Col>
      </Row>
    </>
  );
};

InfosProduit.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func
};

export default InfosProduit;
